import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { getMySavedOpsData } from '~/actions/opportunity.actions';
import { useSearchParams } from 'react-router-dom';
import OpportunityGrid from '~/components/OpportunityGrid/OpportunityGrid';
const MyOpportunitiesGrid = ({ sections, limit, searchQuery = '', country, industry, maxLoadCount = 0, preloadCount = 9, interestedInType = 1, }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const contentTypes = sections && sections.map((sections) => sections.contentTypes).flat();
    const [page, setPage] = useState(Number(searchParams.get('page')) || 1);
    const { data, isLoading, isPlaceholderData } = useQuery({
        queryKey: [contentTypes, searchQuery, country, industry, interestedInType],
        queryFn: async ({ pageParam }) => getMySavedOpsData({
            contentTypes,
            page: pageParam,
            interestedInType,
            country,
            industry,
            size: limit,
            searchQuery,
            maxCount: maxLoadCount,
        }),
        placeholderData: keepPreviousData,
    });
    const tryGetIconTextByType = (typeIds) => {
        var _a, _b;
        return ((_b = (_a = sections.find((section) => {
            return (section.contentTypes.find((type) => typeIds.includes(type)) !=
                undefined);
        })) === null || _a === void 0 ? void 0 : _a.iconText) !== null && _b !== void 0 ? _b : '');
    };
    const onPageChange = (page) => {
        setSearchParams((prev) => {
            const params = new URLSearchParams(prev);
            params.set('page', page.toString());
            return params;
        });
        setPage(page);
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    return (_jsx(_Fragment, { children: _jsx(OpportunityGrid, { data: data, isLoading: isLoading, isPlaceholderData: isPlaceholderData, preloadCount: preloadCount, iconTextFn: tryGetIconTextByType, page: page, onPageChange: onPageChange, heading: (!data || isLoading || isPlaceholderData) && (_jsx("div", Object.assign({ className: "category__heading" }, { children: _jsx("h2", Object.assign({ className: "category__heading__title" }, { children: "Loading..." })) }))), noResults: _jsx("div", Object.assign({ className: "category__no-results" }, { children: _jsx("h3", Object.assign({ className: "heading--no-transform" }, { children: "We didn't find any match for your search in your saved opportunities." })) })) }) }));
};
export default MyOpportunitiesGrid;
